// Бэк режет актуальность ставок целыми московскими днями, поэтому и даты, и
// возраст ставок считаем по Москве, а не по часовому поясу браузера.
const MOSCOW_DATE = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const DAY_MS = 24 * 60 * 60 * 1000;

function dateParts(time: number): { year: string; month: string; day: string } {
  const parts = MOSCOW_DATE.formatToParts(time);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  return { year: part('year'), month: part('month'), day: part('day') };
}

// YYYY-MM-DD — формат параметров actual_from / actual_to.
export function moscowIsoDate(time: number): string {
  const { year, month, day } = dateParts(time);
  return `${year}-${month}-${day}`;
}

/** Сегодняшняя московская дата: «будущая» для бэка считается по Москве, не по браузеру. */
export function todayMoscow(now: Date = new Date()): string {
  return moscowIsoDate(now.getTime());
}

// ДД.ММ.ГГГГ — для показа. Битая дата из ответа — прочерк: Intl на ней
// бросает исключение и уронил бы всю панель.
export function moscowDisplayDate(time: number): string {
  if (!Number.isFinite(time)) return '—';
  const { year, month, day } = dateParts(time);
  return `${day}.${month}.${year}`;
}

// Разница московских календарных дат, а не 24-часовых интервалов: ставка
// вчерашнего вечера — это «1 день назад», как и для фильтра бэка.
export function moscowDaysBetween(from: number, to: number): number {
  const dayNumber = (time: number) => {
    const { year, month, day } = dateParts(time);
    return Date.UTC(Number(year), Number(month) - 1, Number(day)) / DAY_MS;
  };
  return dayNumber(to) - dayNumber(from);
}

// Московская дата N дней назад. Сдвиг сутками точен: перехода на летнее
// время в Москве нет.
export function moscowIsoDateDaysAgo(days: number, now: number): string {
  return moscowIsoDate(now - days * DAY_MS);
}
